/*============================================================================
  variant-add-on.js  ——  可移植「变体加购服务」模块
  ----------------------------------------------------------------------------
  功能:
    1. 渲染一个「附加服务」下拉菜单,其可选项随当前选中的【变体(多属性)】动态变化。
       数据源 = 每个变体的元字段 custom.add_on(变体引用列表,每个变体绑定若干服务变体)。
    2. 点击加购时,把下拉里选中的服务变体作为【独立行项目】与主产品一起加入购物车。

  迁移到其他网站时,只需:
    - 拷贝本文件 + snippets/variant-add-on.liquid
    - 在产品表单内 {% render 'variant-add-on', product: product %}
    - 按需修改下方 CONFIG 里的「主题整合点」(事件名 / 选择器)

  本模块不依赖 jQuery。
============================================================================*/
(function () {
  'use strict';

  /* ----------------------------- 主题整合点 ------------------------------ */
  var CONFIG = {
    // 主题在切换变体时派发的事件;detail.variant 必须包含 .id。
    // 本主题用命名空间事件 variant:change:{section}:{product},此项收不到也没关系:
    // initBlock 里还额外监听了隐藏 [name="id"] 的 change,作为通用变体信号。
    variantChangeEvent: 'variant:change',
    // 加购按钮选择器 —— 本主题产品页主加购是 <button name="add" type="submit">
    addToCartSelector: '[name="add"]',
    // 加购表单选择器
    cartFormSelector: 'form[action*="/cart/add"]',
    // 本主题(Archetype)靠加购响应里的 bundled section 更新购物车抽屉;
    // 传该 section 名即在加购请求带上 sections 参数。其它主题不需要可设 null。
    addSections: 'cart-ajax',
    // 加购成功后:复刻主题原生 <block-buy-buttons> 的通知方式,让抽屉刷新。
    // addResponse 含 sections['cart-ajax'],抽屉据此重绘。
    afterAddDispatch: function (cart, form, btn, addResponse) {
      var host = form.closest('block-buy-buttons') || form;
      host.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product: addResponse, addToCartBtn: btn }
      }));
    },
    // 加购失败回调
    onError: function (data, form) {
      var host = form.closest('block-buy-buttons') || form;
      host.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: { errorMessage: data && data.description }, bubbles: true
      }));
      console.error('[variant-add-on] 加购失败', data);
    },
    // 写到主产品行项目上的属性名(便于商家在订单里看到客户选了哪个服务);设为 null 则不写
    mainItemPropertyName: '_サービス',
    // 下拉选项里价格后缀的文案;不需要则设为 ''
    priceSuffix: '（税込）'
  };
  /* ---------------------------------------------------------------------- */

  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* === 1. 下拉菜单:跟随变体变化重建可选项 ============================== */
  function initBlock(root) {
    if (root.__vaoInit) return;
    root.__vaoInit = true;

    var dataEl = root.querySelector('[data-variant-add-on-data]');
    var select = root.querySelector('[data-variant-add-on-select]');
    if (!dataEl || !select) return;

    var map = {};
    try { map = JSON.parse(dataEl.textContent || '{}'); } catch (e) { map = {}; }

    var placeholder = select.getAttribute('data-placeholder') || '';
    var form = root.closest(CONFIG.cartFormSelector) ||
               document.querySelector(CONFIG.cartFormSelector);

    function currentVariantId() {
      var master = form && form.querySelector('[name="id"]');
      if (master && master.value) return String(master.value);
      return root.getAttribute('data-default-variant') || '';
    }

    function render(variantId) {
      var list = map[String(variantId)] || [];
      var prev = select.value;

      select.innerHTML = '';
      var opt0 = document.createElement('option');
      opt0.value = '';
      opt0.textContent = placeholder;
      select.appendChild(opt0);

      list.forEach(function (item) {
        var o = document.createElement('option');
        o.value = String(item.id);
        // data-label 存完整名称(写入订单属性);显示文字用精简的 name
        o.setAttribute('data-label', item.label || '');
        o.textContent = (item.name || item.label) +
          (item.price ? '  ＋ ' + item.price + CONFIG.priceSuffix : '');
        if (item.available === false) o.disabled = true;
        select.appendChild(o);
      });

      // 若新变体里仍有同一个服务,保留用户的选择
      if (prev && list.some(function (i) { return String(i.id) === prev; })) {
        select.value = prev;
      }

      // 当前变体没有任何附加服务时隐藏整块
      root.style.display = list.length ? '' : 'none';
    }

    render(currentVariantId());

    // 信号1:主题派发的变体切换事件(detail.variant.id)
    document.addEventListener(CONFIG.variantChangeEvent, function (e) {
      var v = e.detail && e.detail.variant;
      render(v ? v.id : '');
    });

    // 信号2(通用):主题切换变体时会更新隐藏 [name="id"] 并派发 change 事件。
    // 覆盖那些用「命名空间事件」或不派发全局 variant 事件的现代主题。
    var masterInput = form && form.querySelector('[name="id"]');
    if (masterInput) {
      masterInput.addEventListener('change', function () { render(currentVariantId()); });
    }
  }

  /* === 2. 全局加购拦截:主产品 + 选中的服务变体一起加入购物车 ========== */
  function gatherProperties(form) {
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '' || el.value == null) return;
      var name = el.getAttribute('name');
      var key = name.slice(name.indexOf('[') + 1, name.lastIndexOf(']'));
      props[key] = el.value;
    });
    return props;
  }

  function selectedAddOns(scope) {
    // 在产品 section 范围内查找(下拉可能位于 <form> 之外的独立块里),去重后返回 [{id, label}]
    var seen = {};
    var out = [];
    scope.querySelectorAll('[data-variant-add-on-select]').forEach(function (sel) {
      if (!sel.value) return;
      if (seen[sel.value]) return;
      seen[sel.value] = true;
      var opt = sel.options[sel.selectedIndex];
      out.push({
        id: parseInt(sel.value, 10),
        label: opt ? (opt.getAttribute('data-label') || opt.textContent.trim()) : ''
      });
    });
    return out;
  }

  function onAddToCart(e) {
    var btn = e.target.closest(CONFIG.addToCartSelector);
    if (!btn) return;
    var form = btn.closest(CONFIG.cartFormSelector) ||
               document.querySelector(CONFIG.cartFormSelector);
    if (!form) return; // 没有加购表单,交回主题处理

    var idField = form.querySelector('[name="id"]');
    var mainId = idField && idField.value;
    if (!mainId) return; // 没有变体 id,交回主题处理

    // 下拉可能位于表单之外的独立 add-on 块,按整个产品 section 查找
    var scope = form.closest('[id^="shopify-section"]') || form.closest('section') || document;
    var addOns = selectedAddOns(scope);

    // 关键:没有选择任何服务时【不接管】,让主题原生加购正常处理主产品。
    // 这样即便本模块出问题,也绝不会影响普通加购。
    if (!addOns.length) return;

    // 选了服务 → 接管加购:阻止主题默认提交,避免主产品被重复加入
    e.preventDefault();
    e.stopImmediatePropagation();

    // ymq 产品选项:接管后 ymq 自己的加购处理器不会执行,
    // 这里调用它的实例完成校验并取出选项值,合并进主产品属性
    var ymqProps = {};
    var ymq = window.best_option && window.best_option.productInstance;
    if (ymq && typeof ymq.buildFormData === 'function') {
      try {
        ymq.buildFormData();
        ymq.validate.validateAll(ymq.formData, true);
        if (ymq.validate.validateCount != 0) return; // 必填未填,ymq 已显示提示
        ymqProps = ymq.getAjaxDataByFormData(true) || {};
      } catch (err) {
        console.error('[variant-add-on] 读取 ymq 选项失败', err);
      }
    }

    var qtyField = form.querySelector('[name="quantity"]');
    var qty = qtyField ? (parseInt(qtyField.value, 10) || 1) : 1;

    var properties = gatherProperties(form);
    Object.keys(ymqProps).forEach(function (k) { properties[k] = ymqProps[k]; });

    var items = [];
    // 服务变体排在主产品之前(与旧版顺序一致)
    addOns.forEach(function (a) {
      items.push({ id: a.id, quantity: qty });
    });
    if (CONFIG.mainItemPropertyName) {
      properties[CONFIG.mainItemPropertyName] = addOns.map(function (a) { return a.label; }).join(' / ');
    }

    var mainItem = { id: parseInt(mainId, 10), quantity: qty };
    if (Object.keys(properties).length) mainItem.properties = properties;
    var sp = form.querySelector('[name="selling_plan"]');
    if (sp && sp.value) mainItem.selling_plan = sp.value;
    items.push(mainItem);

    var body = { items: items };
    // 现代主题(如 Archetype)靠加购响应里的 bundled section 更新购物车抽屉
    if (CONFIG.addSections) {
      body.sections = CONFIG.addSections;
      body.sections_url = window.location.pathname;
    }

    btn.classList.add('btn--loading');

    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.classList.remove('btn--loading');
        if (!res.ok || (res.data && res.data.status >= 400)) {
          CONFIG.onError(res.data, form);
          return;
        }
        var addResponse = res.data; // 含 sections['cart-ajax']
        // 取最新购物车并通知主题刷新抽屉;addResponse 供需要 sections 的主题使用
        return fetch(shopRoot() + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { CONFIG.afterAddDispatch(cart, form, btn, addResponse); });
      })
      .catch(function (err) {
        btn.classList.remove('btn--loading');
        console.error('[variant-add-on] 网络错误', err);
      });
  }

  /* === 说明弹窗 ======================================================== */
  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('variant-add-on--modal-open');
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('variant-add-on--modal-open');
  }
  function modalFor(trigger) {
    if (trigger.__vaoModal) return trigger.__vaoModal;
    var block = trigger.closest('[data-variant-add-on]');
    var modal = block && block.querySelector('[data-variant-add-on-modal]');
    // 移到 body 顶层,避免被带 transform / overflow 的祖先困住导致裁剪、超高显示不全
    if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
    trigger.__vaoModal = modal;
    return modal;
  }

  function onModalClick(e) {
    var trigger = e.target.closest('[data-variant-add-on-info]');
    if (trigger) {
      e.preventDefault();
      openModal(modalFor(trigger));
      return;
    }
    var closer = e.target.closest('[data-variant-add-on-modal-close]');
    if (closer) {
      e.preventDefault();
      closeModal(closer.closest('[data-variant-add-on-modal]'));
    }
  }
  function onModalKey(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-variant-add-on-modal]:not([hidden])').forEach(closeModal);
      return;
    }
    // 触发器为 <span>,支持 Enter / 空格 打开
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      var trigger = e.target.closest && e.target.closest('[data-variant-add-on-info]');
      if (trigger) {
        e.preventDefault();
        openModal(modalFor(trigger));
      }
    }
  }

  /* === 启动 ============================================================ */
  function boot() {
    document.querySelectorAll('[data-variant-add-on]').forEach(initBlock);

    if (!window.__variantAddOnBound) {
      window.__variantAddOnBound = true;
      // 捕获阶段绑定,确保早于主题 / jQuery 的提交处理器执行
      document.addEventListener('click', onAddToCart, true);
      // 说明弹窗(冒泡阶段即可)
      document.addEventListener('click', onModalClick, false);
      document.addEventListener('keydown', onModalKey, false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();